var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#73AF00"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    y: 121.26,
    style: {
      fill: "#FFE15A"
    },
    width: 512,
    height: 269.47
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M0,512l140.415-249.017c2.007-3.57,2.007-10.397,0-13.966L0,0V512z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M230.662,203.329l10.031,30.076l31.704,0.246c4.105,0.032,5.807,5.27,2.505,7.708l-25.504,18.834   l9.563,30.228c1.238,3.914-3.218,7.151-6.557,4.764l-25.793-18.436l-25.793,18.436c-3.339,2.387-7.795-0.85-6.557-4.764   l9.563-30.228l-25.504-18.834c-3.302-2.438-1.6-7.677,2.505-7.708l31.704-0.246l10.031-30.076   C223.856,199.435,229.364,199.435,230.662,203.329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M377.019,203.329l10.031,30.076l31.704,0.246c4.105,0.032,5.807,5.27,2.505,7.708l-25.504,18.834   l9.563,30.228c1.238,3.914-3.218,7.151-6.557,4.764l-25.793-18.436l-25.793,18.436c-3.339,2.387-7.795-0.85-6.557-4.764   l9.563-30.228l-25.504-18.834c-3.302-2.438-1.6-7.677,2.505-7.708l31.704-0.246l10.031-30.076   C370.212,199.435,375.72,199.435,377.019,203.329z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSt);
export default __webpack_public_path__ + "static/media/ST.0b9351267c93598c7edb8f375b6a0e41.svg";
export { ForwardRef as ReactComponent };